import React from "react";

interface ReliefProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Relief: React.FC<ReliefProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.07324 14.5H11.0732V11H14.5732V8H11.0732V4.5H8.07324V8H4.57324V11H8.07324V14.5ZM0.573242 18.5V0.5H18.5732V18.5H0.573242ZM2.57324 16.5H16.5732V2.5H2.57324V16.5Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Relief;
